import { makeStyles } from 'tss-react/mui'

export const useStyles = makeStyles()(theme => ({
  mainContainer: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(7.125),
  },
  sectionsContainer: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(4),
    marginBottom: theme.spacing(14.25),
  },
  loadingContainer: {
    height: '100vh',
  },
  formDisabled: {
    zIndex: 100,
    position: 'relative',
    opacity: 0.7,
    cursor: 'not-allowed',
  },
  disableEvents: {
    pointerEvents: 'none',
  },
  modalText: {
    fontSize: '14px !important',
    fontStyle: 'normal',
    fontWeight: 400,
    lineHeight: '20px !important',
    letterSpacing: '0.25px',
    color: theme.palette.labraText.description,
    fontFamily: theme.typography.fontFamily,
    textAlign: 'left',
  },
  nameBoldText: {
    fontSize: '14px !important',
    fontStyle: 'normal',
    fontWeight: 600,
    lineHeight: '20px !important',
    letterSpacing: '0.1px',
    color: theme.palette.labraText.description,
    fontFamily: theme.typography.fontFamily,
    textAlign: 'left',
  },
  formContainer: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(5),
    marginBottom: theme.spacing(16),
  },
}))
